import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../../lib/index';
import OptionsStep from "./../OptionsStep";
import dateFormat from "dateformat";
import {dateFormatsLocations} from "../../constants/dateFormatsLocations";
import Button from "../../lib/components/Button";


class Slots extends Component {
    constructor(props) {
        super(props);

        this.state = {
            slots: [],
            trigger: false,
            limit: 3,
            limitStep: 3,
            options: new Array(),
            loadMoreButtonShow: false
        };

    }

    componentWillMount() {
        const {data, settings} = this.props;
        dateFormat.i18n = dateFormatsLocations[settings.language];
        var options = [];
        if (data.length > 0) {
            var currentLoopDate = '';
            var i = 0;
            data.forEach(function (item, j, arr) {
                let date_arr = item.slot.split(/[- :]/),
                current_date = new Date(date_arr[0], date_arr[1]-1, date_arr[2], date_arr[3], date_arr[4], date_arr[5]);
                let slot = dateFormat(current_date, "dddd, d mmm HH:MM ");   // Monday, 17 Jan 14:00
                options.push({value: item, label: slot});
            });
            this.setState({
                slots: options,
                loadMoreButtonShow: true
            });
        }else {
            this.setState({
                slots: [],
                loadMoreButtonShow: false
            });
        }
    }

    contactClinic = () => {
        const {settings} = this.props;
        const {texts} = settings;
        this.props.triggerNextStep({
            value: true,
            userAnswer: texts.contactClinic,
            trigger: 'contactUs_start',
        });
    }

    loadMoreSlots = () => {
        // this method will add next day's slots
        const {limit, slots,limitStep} = this.state;
        if (Object.keys(slots).length <= limit+limitStep) {
            this.setState({
                loadMoreButtonShow: false,
                limit: slots.length
            });
            return;
        }
        this.setState({
            limit: limit+limitStep
        });
    }

    getOptions = () => {
        const {limit, slots} = this.state;
        var options = [];
        var i = 0;
        for (let id in slots) {
            i++;
            if (i > limit) {
                break;
            }
            options.push(slots[id]);
        }

        return options;
    };

    render() {
        const {loadMoreButtonShow} = this.state;
        const {step, settings} = this.props;
        let options = this.getOptions();

        return (
            <div>
                <OptionsStep
                    // key={index}
                    options={options}
                    step={step}
                    speak={this.speak}
                    // previousValue={previousStep.value}
                    triggerNextStep={this.props.triggerNextStep}
                    // bubbleOptionStyle={bubbleOptionStyle}
                />
                <div style={{display: options.length === 0 ? "block" : 'flex', justifyContent: 'center',width:'100%' }}>
                    {loadMoreButtonShow ? (
                        <Button onClick={() => this.loadMoreSlots()}>
                            {settings.texts.loadMore}
                        </Button>
                    ) : ('')}
                    {options.length === 0 ? <h4>Not founds available days</h4> : ""}
                    <Button onClick={() => this.contactClinic()}>
                        {settings.texts.contactClinic}
                    </Button>
                </div>

            </div>
        );
    }
}

Slots.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

Slots.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default Slots;
